import { View } from './view';
import { Translations } from '../config/translations';
import { Product } from '../config/product';
import { Util } from '../config/utils';

export class AddonView extends View {

    addonFormContainer: HTMLElement = document.createElement('form');

    renderProductsListForm(products: Product[], currency: string, changeEvent: any) {

        const container = this.getDFContainer();

        this.addonFormContainer.classList.add('hs-form', 'stacked', 'df-f', 'df-f-addon');
        this.addonFormContainer.setAttribute('id', 'df-products-list-form');

        container.appendChild(this.addonFormContainer);

        const checkboxes = document.createElement('ul');
        checkboxes.classList.add('inputs-list', 'multi-container', 'df-addon-list');
        checkboxes.setAttribute('id', 'df-checkbox-container');

        for (const product of products) {

            const checkbox = document.createElement('li');
            checkbox.classList.add('hs-form-checkbox', 'df-addon-item');
            checkbox.innerHTML = `
                <label class='hs-form-radio-display'>
                    <input
                        class='hs-input df-product-checkbox df-checkbox'
                        type='checkbox'
                        name='${product.name}'
                        value='${product.amount}'
                        df_product_id='${product.dfProductId || ''}'
                        payment-type='${product.type}'
                        id='${product.id}'
                        addon-id='${this.generateAddonId(product)}'
                    >
                    <span class='df-f-label df-f-product-addon-label'>
                        <span>${product.name}</span>
                        <span>${this.formatMoney(`${product.amount}`, currency)}</span>
                    </span>
                </label>`;

            checkboxes.appendChild(checkbox);
        }

        this.addonFormContainer.appendChild(this.wrapElementHSStyles('', checkboxes));

        const errorField = document.createElement('div');
        errorField.setAttribute('id', 'df-addon-error-field');
        errorField.innerText = Translations.SELECT_AT_LEAST_ONE_PRODUCT;

        this.addonFormContainer.appendChild(errorField);
        this.addCheckboxEventListeners(changeEvent);
    }

    addCheckboxEventListeners(callback: any) {
        const addonItemElements = document.querySelectorAll('#df-checkbox-container .df-addon-item');
        addonItemElements.forEach(element => {
            (element as HTMLInputElement).onclick = (event: Event) => {
                const target = event.target as HTMLElement;
                const checkbox = target.querySelector('input.df-product-checkbox') as HTMLInputElement;
                if (checkbox) {
                    checkbox.click();
                }
            };
        });

        const checkboxes = this.getCheckboxesForm();
        Array.prototype.forEach.call(checkboxes, (checkbox: HTMLInputElement) => {
            checkbox.onchange = (event) => {
                callback(event);
            };
        });
    }

    preselectDfProductId() {
        const preselectedDfProductIdParam = Util.getUrlParameter('dfpr', window.location.href) || '';
        if (!preselectedDfProductIdParam) {
            return;
        }
        const preselectedDfProductIds = preselectedDfProductIdParam.split(',');

        const addonItemElements = document.querySelectorAll('#df-checkbox-container input[type="checkbox"]');
        addonItemElements.forEach(element => {
            preselectedDfProductIds.forEach(preselectedDfProductId => {
                if (element.getAttribute('df_product_id') === preselectedDfProductId) {
                    (element as HTMLInputElement).click();                
                }
            });
        });
    }

    getCheckboxesForm() {
        return document.getElementsByClassName('df-product-checkbox');
    }

    showErrorAddon() {
        const errorField = this.getHtmlElement('#df-addon-error-field');
        errorField.style.display = 'block';
    }

    hideErrorAddon() {
        const errorField = this.getHtmlElement('#df-addon-error-field');
        errorField.style.display = 'none';
    }

    generateAddonId(product: Product) {
        const productType = product.type;
        const productName = product.name.toLowerCase().replace(/ /g, '_').replace(/[^\w\s]/gi, '');
        const productAmount = `${product.amount}`.replace(/\./g,'_');
        return `${productType}_${productName}_${productAmount}`;
    }


    showForm() {
        this.addonFormContainer.style.display = 'initial';
    }

    hideForm() {
        this.addonFormContainer.style.display = 'none';
    }

}
